module.exports = __webpack_public_path__ + "img/10.34ea5025.png";